import { z } from "zod";
import {
  TAG_IDENTIFIER,
  DISPLAY_LABEL,
  HELPER_TEXT,
  LICENSE_SCOPE,
} from "./consts";

export const addSchema = z.object({
  [TAG_IDENTIFIER]: z.string().min(1, "This field is required"),
  [DISPLAY_LABEL]: z.string().min(1, "This field is required"),
  [LICENSE_SCOPE]: z.string().min(1, "This field is required"),
  [HELPER_TEXT]: z.string().optional(),
});

export type AddZoneFormValues = z.infer<typeof addSchema>;
